import React, { Component } from "react";
import { connect } from "react-redux";

import AlbumFetchingComponent from "./AlbumFetchingComponent";

export class AlbumFetching extends Component {
  render() {
    return <AlbumFetchingComponent />;
  }
}

// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlbumFetching);



// WEBPACK FOOTER //
// ./src/components/Common/AlbumFetching/index.js